<!--
  Do not use h-full + flex-1 min-h-0 here by default: inside DETAIL_PAGE_ROUTE_HOST
  flex chains that collapses the control slot (hairline Kennung/Beschreibung inputs).
  Fill-height list tabs still force height via page-fill-layout.scss on
  .formly-simple-title-control.
-->
<div class="flex w-full min-h-0 flex-col">
    <div class="flex-shrink-0">
        <div class="flex items-center gap-1">
            <!-- Pre-icons section (left side) -->
            <ng-container *ngFor="let preIcon of preIcons(); trackBy: trackByPreIcon">
                <a
                    [href]="preIcon.href"
                    [class]="
                        'clickable text-blue-600 hover:text-blue-800 transition-colors ' +
                        (preIcon.className || '')
                    "
                    [target]="preIcon.target || '_self'"
                    (click)="handleCustomIconClick(preIcon, $event)"
                    [title]="preIcon.tooltip"
                    [attr.data-testid]="props.attributes?.['data-testid'] + '-formly-pre-icon'"
                >
                    <i
                        [class]="preIcon.iconClass"
                        [attr.data-testid]="props.attributes?.['data-testid'] + '-formly-pre-icon'"
                    ></i>
                </a>
            </ng-container>

            <label
                [ngClass]="labelClasses()"
                class="block mb-0 mr-1 text-ellipsis overflow-hidden whitespace-nowrap"
                [pTooltip]="props.hint ?? props.label"
                placement="bottom"
                [attr.data-testid]="props.attributes?.['data-testid'] + '-formly-label'"
            >
                {{ props.label }}
                <ng-container *ngIf="props.required">
                    <span
                        class="text-red-500"
                        [attr.data-testid]="props.attributes?.['data-testid'] + '-formly-required'"
                        >*</span
                    >
                </ng-container>
            </label>

            <i
                *ngIf="hintText"
                class="fa fa-info-circle cursor-help text-color-secondary"
                [pTooltip]="hintText"
                tooltipPosition="bottom"
                [attr.data-testid]="props.attributes?.['data-testid'] + '-hint'"
            ></i>

            <ng-container *ngIf="formControl.value && props.editBasePath">
                <a
                    [href]="props.editBasePath + validIdOfModel()"
                    class="text-blue-600 hover:text-blue-800 transition-colors"
                    target="_blank"
                    [attr.data-testid]="
                        props.attributes?.['data-testid'] + '-formly-edit-base-path'
                    "
                >
                    <i
                        class="fa fa-external-link-alt"
                        [attr.data-testid]="
                            props.attributes?.['data-testid'] + '-formly-edit-base-path'
                        "
                    ></i>
                </a>
            </ng-container>
            <ng-container *ngIf="formControl.value && props.showCopyIcon">
                <a
                    class="clickable text-blue-600 hover:text-blue-800 transition-colors"
                    (click)="copyToClipboard(formControl.value)"
                    [attr.data-testid]="props.attributes?.['data-testid'] + '-formly-copy-icon'"
                >
                    <i
                        class="fa fa-copy"
                        [attr.data-testid]="props.attributes?.['data-testid'] + '-formly-copy-icon'"
                    ></i>
                </a>
            </ng-container>
            <ng-container *ngIf="props.createBasePath">
                <a
                    [href]="props.createBasePath"
                    class="text-blue-600 hover:text-blue-800 transition-colors"
                    target="_blank"
                    [attr.data-testid]="
                        props.attributes?.['data-testid'] + '-formly-create-base-path'
                    "
                >
                    <i
                        class="fa fa-plus"
                        [attr.data-testid]="
                            props.attributes?.['data-testid'] + '-formly-create-base-path'
                        "
                    ></i>
                </a>
            </ng-container>

            <!-- Post-icons section (right side) -->
            <ng-container *ngFor="let postIcon of postIcons(); trackBy: trackByPostIcon">
                <a
                    [href]="postIcon.href"
                    [class]="
                        'text-blue-600 hover:text-blue-800 transition-colors ' +
                        (postIcon.className || '')
                    "
                    [target]="postIcon.target || '_self'"
                    (click)="handleCustomIconClick(postIcon, $event)"
                    [title]="postIcon.tooltip"
                    [attr.data-testid]="props.attributes?.['data-testid'] + '-formly-post-icon'"
                >
                    <i [class]="postIcon.iconClass"></i>
                </a>
            </ng-container>
        </div>

        <hr
            *ngIf="props.hrBelowTitle"
            [ngClass]="props.hrBelowTitleClass"
            class="border-gray-200 !opacity-50"
            [attr.data-testid]="props.attributes?.['data-testid'] + '-formly-hr'"
        />
    </div>
    <div class="formly-simple-title-control w-full min-w-0">
        <ng-container #fieldComponent></ng-container>
    </div>
    <!-- validation message -->
    <div
        class="flex-shrink-0 text-red-500 text-sm mt-1"
        [attr.data-testid]="props.attributes?.['data-testid'] + '-formly-validation-message-div'"
        *ngIf="
            formControl.invalid &&
            (formControl.touched || formControl.dirty) &&
            formControl.status !== 'PENDING'
        "
    >
        <formly-validation-message
            [field]="field"
            [attr.data-testid]="props.attributes?.['data-testid'] + '-formly-validation-message'"
        />
    </div>
</div>
